
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import Vue from 'vue';
  import { Pie } from 'vue-chartjs'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
    } from 'chart.js'

  import Chart from 'chart.js/auto';
  import { IPieDatasetResource } from '@/types/resource.types';
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
  
  @Component({
      name: 'FileCountGraph',
      components: {
        Pie,
        ChartJS
      }
  })
  
  
  export default class ReferenceMatchPie extends Vue {

    /* Props
    ============================================*/
      @Prop({type: Object, required: true})
      readonly referenceMatchDashboard: IPieDatasetResource;
      
    
    randomIterator: number = 0;
    chart: Chart | null;
    chartOpt: Object = {
          responsive: true,
          maintainAspectRatio: false,
            tooltips: {
                displayColors:false
            },
          plugins: {
                legend: {
                    display: false,
                }
            }
        };
    /* Data
    ============================================*/
  myStyles: object = {
        height: '100%',
        width: '100%',
        position: 'relative'
      };
  
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    get chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false
        };
    }
    get hasData(){
      if(!this.referenceMatchDashboard) return false;
      for(let d = 0; d < this.referenceMatchDashboard.data.length; d++){
        if(this.referenceMatchDashboard.data[d] > 0) return true;
      }
      return false;
    }
    chartPlugins() {
        return {
            legend: {
                display: false,
                toggle: false
            }       
        };
    }
    get chartData(){
        if(this.referenceMatchDashboard){
            return {
                labels: this.referenceMatchDashboard.labels,
                datasets: [{
                    data: this.referenceMatchDashboard.data,
                    backgroundColor: ["#00b159","#d11141"]
                }]
            }
        }
        return {labels:[], datasets:[]};
    }
    
  }
  
  
  